/*
 * authAction.js
 * trt_cms2
 *
 * Created by Hisyam on 27/2/2020.
 * Copyright (c) 2020 Terato Tech. All rights reserved.
 */

import {LOGIN, LOGIN_FAIL, LOGIN_SUCCESS, LOGOUT, LOGOUT_SUCCESS, USER_LOADED, USER_LOADING} from "../types";
import {ofType} from "redux-observable";
import {catchError, debounceTime, map, pluck, switchMap, takeUntil, tap, withLatestFrom} from "rxjs/operators";
import {returnErrors} from "../messages/messagesAction";
import {interval, of} from "rxjs";
import {ajax} from "rxjs/ajax";
import {AUTH_API, LOGIN_API, LOGOUT_API} from "../../config/api";
import {apiHeader} from "../../config/helper";

export const loadUser = (milliseconds = 3000) => ({type: USER_LOADING, payload: milliseconds});
const loadUserFulfilled = (payload) => ({type: USER_LOADED, "payload": payload});

export const loadUserEpic = (action$, state$) => action$.pipe(
  ofType(USER_LOADING),
  withLatestFrom(state$),
  switchMap(([, state]) => ajax.getJSON(AUTH_API, apiHeader(state, null)).pipe(
    map(response => loadUserFulfilled(response)),
    catchError(({status, response}) => of(returnErrors(response, status)))
  ))
);

// export const loadUserEpic = (action$, state$) => action$.pipe(
//   ofType(USER_LOADING),
//   switchMap(
//     (action) => interval(action.payload).pipe(
//       withLatestFrom(state$),
//       tap(console.log),
//       switchMap(
//         ([, state]) => ajaxGetJSON(AUTH_API, apiHeader(state, null)).pipe(
//           map(response => loadUserFulfilled(response)),
//           catchError(({status, response}) => of(returnErrors(response, status)))
//         )
//       ),
//       takeUntil(action$.pipe(
//         ofType(LOGOUT)
//       ))
//     )
//   )
// );

export const login = (username, password) => ({type: LOGIN, payload: {username, password}});
const loginSuccess = (payload) => ({type: LOGIN_SUCCESS, payload: payload});

export const loginEpic = action$ => action$.pipe(
  ofType(LOGIN),
  debounceTime(500),
  switchMap(action => ajax.post(LOGIN_API, action.payload).pipe(
    pluck('response'),
    map(loginSuccess),
    catchError(({status, response}) => of({
      type: LOGIN_FAIL,
      payload: {status, response}
    }))
  ))
);

export const logout = () => ({type: LOGOUT});
const logoutSuccess = () => ({type: LOGOUT_SUCCESS});

export const logoutEpic = (action$, state$) => action$.pipe(
  ofType(LOGOUT),
  debounceTime(500),
  withLatestFrom(state$),
  switchMap(([, state]) => ajax.post(LOGOUT_API, null, apiHeader(state, null)).pipe(
    map(response => logoutSuccess()),
    catchError(({status, response}) => of(returnErrors(response, status)))
  ))
);